import * as React from 'react'
import { useField } from 'react-final-form'

const Hidden = ({ name }) => {
  const { input } = useField(name)
  return <input type="hidden" {...input} />
}

export default Hidden
